(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusSelectAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', '$filter', '$modal', 'topBarService', 'actionPlanLookups', 'owners', 'recomActionPlanUpdateStatusService',
        'businessUnit', 'activeProcess', 'recomService', 'notificationService'];

    function Controller($scope, $state, $filter, $modal, topBarService, actionPlanLookups, owners, recomActionPlanUpdateStatusService,
                        businessUnit, activeProcess, recomService, notificationService) {

        var title = businessUnit.TitleEN + ' Action Plans | ' + activeProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.activeProcess = activeProcess;
        $scope.businessUnit = businessUnit;
        $scope.closingProcess = false;

        
        // Check GovernanceProcess
        $scope.validateBusinessUnit = function () {
        };

        $scope.closeGovernanceProcess = function () {
            $scope.activeProcess.IsActive = false;
            $scope.closingProcess = true;
            recomService
                .updateGovernanceProcess($scope.activeProcess)
                .then(function (updatedGovernanceProcess) {
                    notificationService.notify('The Governance Process was closed');

                    if (!updatedGovernanceProcess.IsActive) {
                        $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID }, { reload: true });
                    }
                })
                .finally(function () {
                    $scope.closingProcess = false;
                });
        };

        // Search
        $scope.searchOwners = function (q) {
            var columnsToSearch = ['DisplayName', 'EmployeePositionEN', 'EmployeeDepartmentEN', 'EmployeeEmail'];

            //_.forEach($scope.allStatus, function (status) {
            //    status.displayedItems = $filter('filterBy')(status.items, columnsToSearch, q);
            //});
        };
    }
})();